import { DIC } from "@/const/dic";
import { validateChinese, validatenum } from "@/util/validate";
// import { formatterTime } from "@/util/util";

const validateName = (rule, value, callback) => {
  if (!validateChinese(value) || value.length > 30 || value.length < 1) {
    callback(new Error("分类名称为1-30位中文"));
  } else {
    callback();
  }
};
const validateNumber = (rule, value, callback) => {
  if (!validatenum(value)) {
    callback(new Error("请输入正确的整数数值"));
  } else {
    callback();
  }
};
export const waterProjectTableOption = {
  title: "净水报单",
  align: "center",
  menuAlign: "center",
  headerAlign: "center",
  border: true,
  expand: false,
  stripe: false,
  showHeader: true,
  menuType: "menu",
  size: "mini",
  // align: 'center',
  index: false,
  selection: true,
  menu: true,
  page: true,
  addBtn: false,
  editBtn: false,
  delBtn: false,
  viewBtn: false,
  columnBtn: true,
  // menuWidth: "300",
  // labelWidth: "200",
  defaultSort: {
    prop: "createTime",
    order: "descending",
  },
  column: [
    {
      label: "区域",
      prop: "zone",
      type: "input",
      width: 50,
      search: true,
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "安装类型",
      prop: "installType",
      type: "select",
      dicData: [
        { label: "", value: 0 },
        { label: "业主自安装", value: 1 },
        { label: "公司安装", value: 2 },
      ],
    },
    {
      label: "订单状态",
      prop: "orderStatus",
      type: "select",
      search: true,
      dicData: DIC.ORDER_WATER_STATUS,
    },
    {
      label: "客户姓名",
      prop: "customName",
      span: 12,
      overHidden: true,
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "客户电话",
      prop: "customMobile",
      span: 24,
      overHidden: true,
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "客户地址",
      prop: "customAddress",
      search: true,
      span: 24,
      overHidden: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    {
      label: "创建时间",
      prop: "createTime",
      type: "datetime",
      overHidden: true,
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // 更新时间
    /* {
      label: "更新时间",
      prop: "updateTime",
      type: "datetime",
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    }, */
    {
      label: "产品名称",
      prop: "productName",
      type: "input",
      overHidden: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "是否预埋管线",
      prop: "preEmbedded",
      type: "input",
      width: 50,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "预计长度(米)",
      prop: "lineLength",
      type: "input",
      width: 50,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    {
      label: "安装额外费用支付方",
      prop: "additionalLaborPayer",
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    /* {
      label: "产品价格",
      prop: "retailPrice",
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },*/
    {
      label: "付款凭证",
      prop: "picUrl",
      span: 24,
      overHidden: true,
      solt: true,
      formsolt: true,
    },
    {
      label: "店铺名称",
      prop: "shopName",
      overHidden: true,
      type: "input",
      search: true,
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    // 店铺电话
    {
      label: "店铺电话",
      prop: "shopMobile",
      overHidden: true,
      search: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateNumber,
        },
      ],
    },
    // 店铺地址
    {
      label: "店铺地址",
      prop: "shopAddress",
      overHidden: true,
      type: "input",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    },
    /*     {
      label: "安装时间",
      prop: "installTime",
      type: "datetime",
      overHidden: true,
      format: "yyyy-MM-dd HH:mm:ss",
      valueFormat: "timestamp",
      rules: [
        {
          required: true,
          trigger: "blur",
          validator: validateName,
        },
      ],
    }, */
    {
      label: "备注",
      prop: "remarks",
      overHidden: true,
      type: "textarea",
      span: 24,
      max: 255,
    },
    {
      label: "返利状态",
      prop: "status",
      type: "input",
      dicData: DIC.REBATE_STATUS,
      // search: true,
    },
    {
      label: "返利金额",
      prop: "rebateAmount",
      type: "input",
    },
    {
      label: "返利人",
      prop: "reference",
      overHidden: true,
      type: "input",
      // search: true,
    },
    {
      label: "创建人",
      prop: "createBy",
      type: "input",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    // 是否已安装
    {
      label: "是否已安装",
      prop: "isInstall",
      type: "input",
      dicData: DIC.YES_NO,
    },
    {
      label: "安装时间",
      prop: "installTime",
      type: "datetime",
      overHidden: true,
      sortable: true,
      format: "yyyy-MM-dd HH:mm:ss",
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "实际安装时间",
      prop: "actualInstallTime",
      type: "datetime",
      overHidden: true,
      solt: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "开始时间",
      prop: "timeStart",
      type: "datetime",
      search: true,
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "结束时间",
      prop: "timeEnd",
      search: true,
      type: "datetime",
      valueFormat: "timestamp",
      format: "yyyy-MM-dd HH:mm:ss",
      hide: true,
      addVisdiplay: false,
      editVisdiplay: false,
    },
    {
      label: "订单信息",
      prop: "name",
      children: [
        {
          label: "实付金额",
          prop: "payMoney",
        },

        {
          label: "支付时间",
          prop: "payTime",
          type: "datetime",
          valueFormat: "timestamp",
          format: "yyyy-MM-dd HH:mm:ss",
          overHidden: true,
          addVisdiplay: false,
          editVisdiplay: false,
        },
        // couponName
        {
          label: "优惠券",
          prop: "couponName",
        },
        {
          label: "优惠金额",
          prop: "discountAmount",
        },
        {
          label: "退款金额",
          prop: "refundAmount",
        },
        {
          label: "退款状态",
          prop: "refundStatus",
          type: "input",
          solt: true,
          /* dicData:[
            {
              label: "已退款",
              value: "REFUND_PAY",
            },
            {
              label: "部分退款",
              value: "PARTIAL_REFUND",
            },
            {
              label: "未退款",
              value: "NOT_REFUNDED",
            },
          ] */
        },
      ],
    },
  ],
};
